// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.burger-menu {
  position: relative;
  width: 100%;
}

/* Toggle Button */
.burger-menu__toggle {
  display: flex;
  flex-direction: column;
  position: absolute;
  top: 50%;
  right: 0px;
  transform: translateY(-50%);
  margin: 0;
  justify-content: space-between;
  width: 28px;
  height: 23px;
  background-color: transparent;
  border: none;
  cursor: pointer;
  padding: 0;
  z-index: 1003;
}

.burger-menu__bar {
  width: 100%;
  height: 3px;
  background-color: white;
  transition: transform 0.3s ease;
}

/* X button animation */
.burger-menu__toggle_type_open .burger-menu__bar:nth-child(1) {
  transform: translateY(10px) rotate(45deg);
}
.burger-menu__toggle_type_open .burger-menu__bar:nth-child(2) {
  opacity: 0;
}
.burger-menu__toggle_type_open .burger-menu__bar:nth-child(3) {
  transform: translateY(-10px) rotate(-45deg);
}

/* NAV Default (Mobile full screen) */
.burger-menu__nav {
  position: fixed;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  display: flex;
  flex-direction: column;
  align-items: center;
  height: 100vh;
  width: 0px;
  background-color: rgba(144, 110, 103, 1);
  overflow: hidden;
  transition: width 0.3s ease;
  z-index: 1002;
}

.burger-menu__nav_type_open {
  width: 763px;
}

/* NAV Content */
.burger-menu__list {
  list-style: none;
  padding: 0;
  margin: 160px 0 300px 0;
}

.burger-menu__item {
  margin-bottom: 28px;
  text-align: center;
  color: white;
  font-size: 25px;
  font-weight: 400;
  line-height: 30px;
  cursor: pointer;
  transition: all 0.1s;
}

.burger-menu__item:hover {
  font-weight: 700;
  font-size: 30px;
}

/* Overlay */
.burger-menu__overlay {
  position: fixed;
  top: 0;
  left: 0;
  width: 100vw;
  height: 100vh;
  background-color: black;
  opacity: 0;
  display: none;
  z-index: 1000;
  transition: opacity 0.3s ease;
}

.burger-menu__overlay_type_opened {
  opacity: 0.3;
  display: block;
}

/* Account Button */
.burger-menu__account {
  margin: 0px auto 0 auto;
  width: 100px;
  height: 32px;
  background-color: rgba(48, 48, 48, 1);
  border: none;
  border-radius: 20px;
  cursor: pointer;
  color: white;
  font-size: 14px;
  font-weight: 500;
  line-height: 16px;
  transition: all 0.3s;
}

.burger-menu__account:hover {
  opacity: 0.8;
}

/* ============================= */
/* 📱 TABLET VIEW: 764px–1024px */
/* ============================= */
@media (min-width: 763px) and (max-width: 1023px) {
  .burger-menu__nav {
    top: 0;
    left: auto;
    right: 0;
    transform: translateX(100%);
    width: 60%;
    height: 100vh;
    border-radius: 10px 0 0 10px;
    transition: transform 0.3s ease;
    padding-top: 80px;
  }

  .burger-menu__nav_type_open {
    transform: translateX(0);
  }

  .burger-menu__list {
    margin: 0;
  }

  .burger-menu__item {
    font-size: 20px;
    line-height: 26px;
    margin-bottom: 24px;
  }

  .burger-menu__item:hover {
    font-size: 24px;
  }

  .burger-menu__account {
    width: 120px;
    height: 36px;
    font-size: 16px;
  }
}
`, "",{"version":3,"sources":["webpack://./src/components/BurgerMenu/BurgerMenu.css"],"names":[],"mappings":"AAAA;EACE,kBAAkB;EAClB,WAAW;AACb;;AAEA,kBAAkB;AAClB;EACE,aAAa;EACb,sBAAsB;EACtB,kBAAkB;EAClB,QAAQ;EACR,UAAU;EACV,2BAA2B;EAC3B,SAAS;EACT,8BAA8B;EAC9B,WAAW;EACX,YAAY;EACZ,6BAA6B;EAC7B,YAAY;EACZ,eAAe;EACf,UAAU;EACV,aAAa;AACf;;AAEA;EACE,WAAW;EACX,WAAW;EACX,uBAAuB;EACvB,+BAA+B;AACjC;;AAEA,uBAAuB;AACvB;EACE,yCAAyC;AAC3C;AACA;EACE,UAAU;AACZ;AACA;EACE,2CAA2C;AAC7C;;AAEA,qCAAqC;AACrC;EACE,eAAe;EACf,QAAQ;EACR,SAAS;EACT,gCAAgC;EAChC,aAAa;EACb,sBAAsB;EACtB,mBAAmB;EACnB,aAAa;EACb,UAAU;EACV,wCAAwC;EACxC,gBAAgB;EAChB,2BAA2B;EAC3B,aAAa;AACf;;AAEA;EACE,YAAY;AACd;;AAEA,gBAAgB;AAChB;EACE,gBAAgB;EAChB,UAAU;EACV,uBAAuB;AACzB;;AAEA;EACE,mBAAmB;EACnB,kBAAkB;EAClB,YAAY;EACZ,eAAe;EACf,gBAAgB;EAChB,iBAAiB;EACjB,eAAe;EACf,oBAAoB;AACtB;;AAEA;EACE,gBAAgB;EAChB,eAAe;AACjB;;AAEA,YAAY;AACZ;EACE,eAAe;EACf,MAAM;EACN,OAAO;EACP,YAAY;EACZ,aAAa;EACb,uBAAuB;EACvB,UAAU;EACV,aAAa;EACb,aAAa;EACb,6BAA6B;AAC/B;;AAEA;EACE,YAAY;EACZ,cAAc;AAChB;;AAEA,mBAAmB;AACnB;EACE,uBAAuB;EACvB,YAAY;EACZ,YAAY;EACZ,qCAAqC;EACrC,YAAY;EACZ,mBAAmB;EACnB,eAAe;EACf,YAAY;EACZ,eAAe;EACf,gBAAgB;EAChB,iBAAiB;EACjB,oBAAoB;AACtB;;AAEA;EACE,YAAY;AACd;;AAEA,kCAAkC;AAClC,iCAAiC;AACjC,kCAAkC;AAClC;EACE;IACE,MAAM;IACN,UAAU;IACV,QAAQ;IACR,2BAA2B;IAC3B,UAAU;IACV,aAAa;IACb,4BAA4B;IAC5B,+BAA+B;IAC/B,iBAAiB;EACnB;;EAEA;IACE,wBAAwB;EAC1B;;EAEA;IACE,SAAS;EACX;;EAEA;IACE,eAAe;IACf,iBAAiB;IACjB,mBAAmB;EACrB;;EAEA;IACE,eAAe;EACjB;;EAEA;IACE,YAAY;IACZ,YAAY;IACZ,eAAe;EACjB;AACF","sourcesContent":[".burger-menu {\r\n  position: relative;\r\n  width: 100%;\r\n}\r\n\r\n/* Toggle Button */\r\n.burger-menu__toggle {\r\n  display: flex;\r\n  flex-direction: column;\r\n  position: absolute;\r\n  top: 50%;\r\n  right: 0px;\r\n  transform: translateY(-50%);\r\n  margin: 0;\r\n  justify-content: space-between;\r\n  width: 28px;\r\n  height: 23px;\r\n  background-color: transparent;\r\n  border: none;\r\n  cursor: pointer;\r\n  padding: 0;\r\n  z-index: 1003;\r\n}\r\n\r\n.burger-menu__bar {\r\n  width: 100%;\r\n  height: 3px;\r\n  background-color: white;\r\n  transition: transform 0.3s ease;\r\n}\r\n\r\n/* X button animation */\r\n.burger-menu__toggle_type_open .burger-menu__bar:nth-child(1) {\r\n  transform: translateY(10px) rotate(45deg);\r\n}\r\n.burger-menu__toggle_type_open .burger-menu__bar:nth-child(2) {\r\n  opacity: 0;\r\n}\r\n.burger-menu__toggle_type_open .burger-menu__bar:nth-child(3) {\r\n  transform: translateY(-10px) rotate(-45deg);\r\n}\r\n\r\n/* NAV Default (Mobile full screen) */\r\n.burger-menu__nav {\r\n  position: fixed;\r\n  top: 50%;\r\n  left: 50%;\r\n  transform: translate(-50%, -50%);\r\n  display: flex;\r\n  flex-direction: column;\r\n  align-items: center;\r\n  height: 100vh;\r\n  width: 0px;\r\n  background-color: rgba(144, 110, 103, 1);\r\n  overflow: hidden;\r\n  transition: width 0.3s ease;\r\n  z-index: 1002;\r\n}\r\n\r\n.burger-menu__nav_type_open {\r\n  width: 763px;\r\n}\r\n\r\n/* NAV Content */\r\n.burger-menu__list {\r\n  list-style: none;\r\n  padding: 0;\r\n  margin: 160px 0 300px 0;\r\n}\r\n\r\n.burger-menu__item {\r\n  margin-bottom: 28px;\r\n  text-align: center;\r\n  color: white;\r\n  font-size: 25px;\r\n  font-weight: 400;\r\n  line-height: 30px;\r\n  cursor: pointer;\r\n  transition: all 0.1s;\r\n}\r\n\r\n.burger-menu__item:hover {\r\n  font-weight: 700;\r\n  font-size: 30px;\r\n}\r\n\r\n/* Overlay */\r\n.burger-menu__overlay {\r\n  position: fixed;\r\n  top: 0;\r\n  left: 0;\r\n  width: 100vw;\r\n  height: 100vh;\r\n  background-color: black;\r\n  opacity: 0;\r\n  display: none;\r\n  z-index: 1000;\r\n  transition: opacity 0.3s ease;\r\n}\r\n\r\n.burger-menu__overlay_type_opened {\r\n  opacity: 0.3;\r\n  display: block;\r\n}\r\n\r\n/* Account Button */\r\n.burger-menu__account {\r\n  margin: 0px auto 0 auto;\r\n  width: 100px;\r\n  height: 32px;\r\n  background-color: rgba(48, 48, 48, 1);\r\n  border: none;\r\n  border-radius: 20px;\r\n  cursor: pointer;\r\n  color: white;\r\n  font-size: 14px;\r\n  font-weight: 500;\r\n  line-height: 16px;\r\n  transition: all 0.3s;\r\n}\r\n\r\n.burger-menu__account:hover {\r\n  opacity: 0.8;\r\n}\r\n\r\n/* ============================= */\r\n/* 📱 TABLET VIEW: 764px–1024px */\r\n/* ============================= */\r\n@media (min-width: 763px) and (max-width: 1023px) {\r\n  .burger-menu__nav {\r\n    top: 0;\r\n    left: auto;\r\n    right: 0;\r\n    transform: translateX(100%);\r\n    width: 60%;\r\n    height: 100vh;\r\n    border-radius: 10px 0 0 10px;\r\n    transition: transform 0.3s ease;\r\n    padding-top: 80px;\r\n  }\r\n\r\n  .burger-menu__nav_type_open {\r\n    transform: translateX(0);\r\n  }\r\n\r\n  .burger-menu__list {\r\n    margin: 0;\r\n  }\r\n\r\n  .burger-menu__item {\r\n    font-size: 20px;\r\n    line-height: 26px;\r\n    margin-bottom: 24px;\r\n  }\r\n\r\n  .burger-menu__item:hover {\r\n    font-size: 24px;\r\n  }\r\n\r\n  .burger-menu__account {\r\n    width: 120px;\r\n    height: 36px;\r\n    font-size: 16px;\r\n  }\r\n}\r\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
